import { render, staticRenderFns } from "./IrisSelectDropdown.vue?vue&type=template&id=164ac2da&"
import script from "./IrisSelectDropdown.vue?vue&type=script&lang=ts&"
export * from "./IrisSelectDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./IrisSelectDropdown.vue?vue&type=style&index=0&id=164ac2da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports